import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';
import { d as defineCustomElement$1 } from './cosmos-text2.js';
import { b as bem } from './bem.js';

const cosmosSelectValueCss = ":host{display:block;margin:0 !important;max-width:100%;position:relative}.cosmos-select-value{-ms-flex-align:center;align-items:center;border-radius:4px;-webkit-box-sizing:border-box;box-sizing:border-box;cursor:default;display:-ms-flexbox;display:flex;gap:var(--cosmos-select-gap, 8px);margin:0;max-width:100%;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;width:100%;--cosmos-text-color:var(--cosmos-select-color, currentColor);--cosmos-text-font-family:var(--cosmos-select-font-family);--cosmos-text-font-size:var(--cosmos-select-font-size);--cosmos-text-font-style:var(--cosmos-select-font-style);--cosmos-text-font-weight:var(--cosmos-select-font-weight);--cosmos-text-letter-spacing:var(--cosmos-select-letter-spacing);--cosmos-text-line-height:var(--cosmos-select-line-height);--cosmos-text-text-transform:var(--cosmos-select-text-transform)}.cosmos-select-value__label{overflow:hidden}.cosmos-select-value ::slotted([slot=prefix]){-ms-flex:0 0 auto;flex:0 0 auto}";
const CosmosSelectValueStyle0 = cosmosSelectValueCss;

const generateClassNames = bem('cosmos-select-value');
const CosmosSelectValue = /*@__PURE__*/ proxyCustomElement(class CosmosSelectValue extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    render() {
        return (h(Host, null, h("div", { class: generateClassNames(), part: "base" }, h("slot", { "aria-hidden": "true", name: "prefix" }), h("cosmos-text", { exportparts: "base: label", class: generateClassNames('label'), size: "small", clamp: 1 }, h("span", null, h("slot", null))))));
    }
    get element() { return this; }
    static get style() { return CosmosSelectValueStyle0; }
}, [1, "cosmos-select-value"]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-select-value", "cosmos-text"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-select-value":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosSelectValue);
            }
            break;
        case "cosmos-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}

export { CosmosSelectValue as C, defineCustomElement as d };
